/* eslint-disable import/prefer-default-export */
export const CREATE_ACCOUNT = 'createAccount';
export const EXTEND_ACCOUNT = 'extendAccount';
export const SHOP = 'shop';
